<template>
  <div id="app">
    <!--<img alt="Vue logo" src="./assets/logo.png">-->
    <router-view></router-view>

    <div class="feedback__button" @click="showFeedback = true">Give feedback</div>
    <div class="overlay" v-if="showFeedback">
      <div class="overlay__holder">
        <div class="overlay__title">
          <strong>Leave feedback</strong>
          <div class="overlay__close" @click="showFeedback = false">&times;</div>
        </div>
        <div class="overlay__content">
          <div v-if="!posted">
          <p>We want to know what issues you ran into, or what suggestions you have for us! <strong>Let us know, so we can create an awesome tool!</strong></p>
          <div class="form-group">
            <label>Feedback</label>
            <textarea v-model="feedback.message"></textarea>
          </div>
          </div>
          <div v-else>
            <p>Thank you very much for your feedback!</p>
          </div>
        </div>
        <footer v-if="!posted" class="overlay__footer">
          <button class="button" @click="addFeedback">Send feedback</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      feedback: {
        message: null,
        page: null
      },
      showFeedback: false,
      posted: false
    }
  },
  methods: {
    addFeedback: function() {
        this.feedback.page = this.$route.path
        this.$store.dispatch('addFeedback', this.feedback).then(() => {
          this.feedback = {
            message: null,
            page: null
          }
          this.posted = true
        })
    },
  }
}
</script>
